import { TaiZenLogo } from "@/app/components/ui";

export const ErrorCaptcha = () => {
   return (
      <div className="flex min-h-screen items-center justify-center p-6">
         <div className="max-w-md text-center space-y-3">
            <TaiZenLogo title="Tai Zen Ai" />
            <p className="text-sm text-muted-foreground">
               Missing reCAPTCHA site key. Please set
               <code className="mx-1">NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY</code>
               in your environment.
            </p>
         </div>
      </div>
   );
};
